import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import modalConnect from '@saucelabs/sl-container-modal';
import { Modal } from '@saucelabs/sl-component-overlay';
import { BadgeConfigurator } from '@saucelabs/sl-component-badge-configurator';


const MODAL_NAME = 'badgeConfiguratorModal';

const BadgeConfiguratorModal = memo((props) => {
  const { buildId, onHide, show, username } = props;

  return (
    <Modal
      dialogClassName={MODAL_NAME}
      onHide={onHide}
      show={show}
    >
      <Modal.Header>
        <Modal.Title>Build Status Banners</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BadgeConfigurator
          buildId={buildId}
          copyTextContainer={`.${MODAL_NAME}`}
          username={username}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          category="action"
          material
          onClick={onHide}
          size="sm"
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}, (prevProps, nextProps) => prevProps.show === nextProps.show && !nextProps.show);

BadgeConfiguratorModal.propTypes = {
  buildId: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
};

export default modalConnect('badgeConfigurator', BadgeConfiguratorModal);
export { BadgeConfiguratorModal };
